import {
  Box,
  Flex,
  Icon,
  IconButton,
  Button,
  Text
} from "@chakra-ui/react";
import { BackupService } from "../../services/backup.service"; // crie esse arquivo
import {
  FiUsers,
  FiMap,
  FiHome,
  FiFileText,
  FiBriefcase,
  FiClipboard,
  FiCalendar,
  FiMenu,
  FiLogOut
} from "react-icons/fi";

import { NavLink } from "react-router-dom";
import { colors } from "../../theme/colors";

interface Props {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

function logout() {
  localStorage.removeItem("token");
  window.location.reload();
}

export default function Sidebar({ collapsed, setCollapsed }: Props) {

  const menus = [
    { label: "Fichas", icon: FiFileText, path: "/" },
    { label: "Lideranças", icon: FiUsers, path: "/liderancas" },
    { label: "Zonas", icon: FiMap, path: "/zonas" },
    { label: "Sessões", icon: FiHome, path: "/sessoes" },
    { label: "Profissionais", icon: FiBriefcase, path: "/profissionais" },
    { label: "Procedimentos", icon: FiClipboard, path: "/procedimentos" },
    { label: "Agendamentos", icon: FiCalendar, path: "/agendamentos" }
  ];

  return (
    <Box
      bg={colors.sidebar}
      h="100vh"
      w={collapsed ? "80px" : "260px"}
      position="fixed"
      left={0}
      top={0}
      color="white"
      transition="0.2s"
    >
      {/* HEADER */}
      <Flex
        h="70px"
        align="center"
        justify="space-between"
        px={4}
        borderBottom="1px solid #1E293B"
      >
        {!collapsed && (
          <Text fontWeight="bold">Sistema Fichas</Text>
        )}

        <IconButton
          aria-label="menu"
          icon={<FiMenu />}
          onClick={() => setCollapsed(!collapsed)}
          bg="transparent"
          _hover={{ bg: "gray.700" }}
        />
      </Flex>

      {/* MENU */}
      <Box mt={2}>
        {menus.map((item) => (
          <NavLink key={item.path} to={item.path}>
            {({ isActive }) => (
              <Flex
                mx={2}
                mt={2}
                p={3}
                borderRadius="10px"
                align="center"
                gap={3}
                bg={isActive ? colors.sidebarActive : "transparent"}
                _hover={{ bg: colors.sidebarHover }}
              >
                <Icon as={item.icon} boxSize={5} />
                {!collapsed && <Text>{item.label}</Text>}
              </Flex>
            )}
          </NavLink>
        ))}
      </Box>

      {/* LOGOUT */}
      <Box position="absolute" bottom="20px" width="100%">
        {/* <Flex
          mx={2}
          p={3}
          borderRadius="10px"
          align="center"
          gap={3}
        >
          <Button
            colorScheme="teal"
            width="100%"
            onClick={(e) => {
              e.stopPropagation();
              BackupService.fazerBackup();
            }}
          >
            Fazer Backup do Banco
          </Button>
        </Flex> */}
        <Flex
          mx={2}
          p={3}
          borderRadius="10px"
          align="center"
          gap={3}
          cursor="pointer"
          _hover={{ bg: colors.sidebarHover }}
          onClick={logout}
        >
          <Icon as={FiLogOut} boxSize={5} />
          {!collapsed && <Text>Sair</Text>}
        </Flex>
      </Box>
    </Box>
  );
}